import React from 'react';
import { ScheduleClinicianManagement } from '../ScheduleClinicianManagement';
import {
  envUrlClinicianManagment,
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
  routes,
} from '../../config';
import cookieService from '../../services/cookieService';
import providerService from '../../services/providerService';
import featureFlagService from '../../services/featureFlagService';
import useClinicOperationHandlers from '../../hooks/useClinicOperationHandlers';

const MyProfile = () => {
  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails() || {};
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;
  const remoteModulePath = 'clinicianManagement/ClinicianApp';
  const featureFlags = featureFlagService.getFeatureFlags();
  const operationHandlers = useClinicOperationHandlers();

  const clinicManagementConfig = {
    enabled: true,
    scheduleCMScriptPath: `${envUrlClinicianManagment}/static/chunks/remoteEntry.js`,
    remoteModulePath,
    remoteCheck: featureFlags.remoteCheck,
  };

  return (
    <>
      <ScheduleClinicianManagement
        config={clinicManagementConfig}
        rcRemoteModuleKey={1}
        accessToken={accessToken}
        idToken={idToken}
        selectedProviderId={providerId}
        pageType="my-account"
        logoutUrl={logoutUrl}
        operationHandlers={operationHandlers}
      />
    </>
  );
};

export default MyProfile;
